import { Component } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    templateUrl: "./change-password-modal.component.html",
    styleUrls: ["./change-password-modal.component.less"],
})
export class ChangePasswordModalComponent {
    constructor(public activeModal: ModalRef) {}

    public closeModal(): void {
        this.activeModal.dismiss()
    }
}
